/* tslint:disable */
import {
  App,
  Entity
} from '../index';

declare var Object: any;
export interface EntitysearchlayoutInterface {
  name: string;
  label: string;
  fields?: Array<string>;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  appId?: any;
  entityId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
  entity?: Entity;
}

export class Entitysearchlayout implements EntitysearchlayoutInterface {
  name: string;
  label: string;
  fields: Array<string>;
  lastupdatedby: string;
  createdby: string;
  id: any;
  appId: any;
  entityId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  entity: Entity;
  constructor(data?: EntitysearchlayoutInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Entitysearchlayout`.
   */
  public static getModelName() {
    return "Entitysearchlayout";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Entitysearchlayout for dynamic purposes.
  **/
  public static factory(data: EntitysearchlayoutInterface): Entitysearchlayout{
    return new Entitysearchlayout(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Entitysearchlayout',
      plural: 'entitysearchlayouts',
      properties: {
        name: {
          name: 'name',
          type: 'string'
        },
        label: {
          name: 'label',
          type: 'string'
        },
        fields: {
          name: 'fields',
          type: 'Array&lt;string&gt;'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        entityId: {
          name: 'entityId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
        entity: {
          name: 'entity',
          type: 'Entity',
          model: 'Entity'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Entitysearchlayout.ts